export const translations = {
  en: {
    brand: "Arcana Mystique",
    tagline: "Tarot readings",
    taglineLine2: "Whispered by the sages",
    subhero:
      "The 78 arcana tell a coherent story: your consultant card, then a five-card cross woven into a living reading.",
    langLabel: "Language",
    nav: {
      home: "Oracle",
      history: "Journal",
      begin: "Begin the reading",
      login: "Sign in",
      register: "Create an account",
      logout: "Sign out",
      account: "Account",
      credits: "credits",
      credit: "credit",
      newConsultant: "New consultant",
      contact: "Contact",
    },
    auth: {
      loginTitle: "Sign in",
      registerTitle: "Create your account",
      emailLabel: "Email",
      passwordLabel: "Password",
      firstNameLabel: "First name",
      firstNameHelp: "Max 15 characters, letters and hyphens only.",
      submitLogin: "Sign in",
      submitRegister: "Create my account",
      toRegister: "No account yet? Create one",
      toLogin: "Already have an account? Sign in",
      welcomeCredit: "Welcome — up to 3 free readings every day.",
      needAuth: "Sign in or create an account to draw the cards.",
      inlineTitle: "Continue to the Oracle",
      inlineSubtitle: "First name & account — takes 20 seconds.",
      alreadyAccount: "I already have an account",
      inlineContinueSignedIn: "Continue as",
      welcomePageTitle: "Welcome,",
      welcomePageIntro: "The ritual is a short one. Four gestures, one story.",
      welcomeStartCta: "Begin the reading",
    },
    usage: {
      title: "THREE FREE READINGS MAX PER DAY",
      subtitle: "3 readings per day, completely free.",
      body: "Every day at midnight (UTC), the counter is reset.\nDraw, reflect, come back tomorrow.",
      badge: "of 3 today",
      unlimited: "Unlimited",
      limitReachedTitle: "You've reached your 3 free readings today",
      limitReachedBody: "Come back tomorrow — your daily allowance renews at midnight UTC.",
    },
    disclaimer: {
      title: "IMPORTANT NOTICE",
      body:
        "This site is intended for entertainment and personal reflection only. The information and interpretations presented do not constitute professional advice. Each consultant remains fully responsible for their choices, decisions and actions taken as a result of using this site. By using this site, the consultant acknowledges acting under their own responsibility.",
      accept: "I have read and accept the terms.",
      mustAccept: "You must accept the terms to continue.",
    },
    home: {
      ritual: "The Ritual",
      cardOfTheDay: "Card of the Day",
      dailyTitle: "Your card of the day",
      cardOfTheDayIntro: "here is your card of the day. Turn it over: it will set the tone of your day.",
      cardOfTheDayReveal: "Reveal today's card",
      cardOfTheDayRevealing: "Turning the card…",
      cardOfTheDayDate: "Today",
      questionOfTheDay: "Question to carry through the day",
      chooseTitle: "Select a reading",
      dailyBtn: "Card of the day",
      readingBtn: "Five-card reading",
      steps: [
        { t: "I · The Consultant Card", d: "A first card is drawn to describe you at this very moment. The oracle interprets it aloud." },
        { t: "II · The Question", d: "Ask a precise question — or let the wisdom of the tarot flow freely." },
        { t: "III · The Cross of Five", d: "You place five cards: strengths, obstacles, evolution, outcome, synthesis." },
        { t: "IV · The Story", d: "The oracle links every card, weaves symbols and contradictions into one coherent story." },
      ],
      start: "Begin the reading",
      deckInfo: "78 arcana · Major & Minor · always upright",
    },
    daily: {
      goReading: "Go to the reading",
      finish: "Finish",
    },
    reading: {
      phase: {
        firstName: "Your first name",
        consultant: "The Consultant",
        question: "Select your question:",
        cross: "The Cross of Five",
        result: "The Reading",
      },
      consultantLabel: "Consultant",
      firstNamePrompt: "Before we begin, tell the oracle your first name.",
      firstNamePlaceholder: "Your first name",
      firstNameContinue: "Continue",
      firstNameError: "Letters and hyphens only (max 15).",
      shuffle: "Shuffle the deck",
      shuffling: "Shuffling…",
      drawConsultant: "Draw the consultant card",
      drawing: "Drawing…",
      consultantIs: "Your consultant card is",
      consultantInterp: "The oracle sees you",
      fiveCardsTitle: "THE 5 CARDS OF YOUR READING",
      ritualIIIIntro: "FOCUS AND CUT THE DECK 5 TIMES TO CHOOSE YOUR CARDS",
      deckLabel: "The deck · {n} cards",
      cutPileLabel: "Cut aside · {n} cards",
      cutAction: "Cut the deck",
      cutsDone: "Five cuts made",
      cutsOf: "Cuts: {a}/5",
      cutKeyHint: "or press Space · Enter",
      cutHint: "Click the deck to cut it: the card revealed by each cut joins your cross, face down. The cut portion is set aside.",
      ritualIIIGoUnder: "SCROLL DOWN TO PICK YOUR 5 ARCANA FROM THE 78 CARDS OF THE TAROT",
      thinking: "The oracle is thinking…",
      continueToQuestion: "Continue",
      chooseQuestionMode: "A personalised question or the Wisdom of the Tarot",
      questionCustomBtn: "Personalised question",
      questionWisdomBtn: "Wisdom of the tarot",
      questionLabel: "Your question (3 lines max)",
      questionPlaceholder: "What weighs on your heart today?",
      questionUnclear: "The Oracle doesn't understand the question. Please rephrase it.",
      noQuestion: "I ask for the wisdom of the tarot",
      continueToCross: "Continue — draw the cross",
      pickPrompt: "Pick a card for position",
      selectedOf: "Placed: {a}/5",
      reveal: "Reveal & interpret",
      revealing: "The cards are speaking…",
      restart: "Start over",
      backToTop: "To copy — back to top",
      pickCardChime: "Please pick a card",
      newQuestion: "Ask another question · keep this consultant",
      endSession: "End the session",
      copy: "Copy the reading",
      copied: "Copied to your clipboard.",
      print: "Print / save as PDF",
      downloadImage: "Download PNG",
      shareImage: "Share the image",
      emailMemo: "Receive by email",
      dailyCardBtn: "Card of the day",
      emailMemoTitle: "Receive a copy of this reading by email",
      emailMemoHint: "Your address is used only to send this message and is never stored.",
      emailMemoSend: "Send me the reading",
      emailMemoSending: "Sending…",
      emailMemoSent: "Your reading is on its way to your inbox.",
      emailMemoFailed: "The reading could not be sent. Please try again shortly.",
      emailMemoInvalid: "Please enter a valid email address.",
      sharing: "Preparing the image…",
      shared: "Your reading has been shared.",
      shareTitle: "My tarot reading · Arcana Mystique",
      shareText: "Here is my tarot reading, drawn on Arcana Mystique.",
      downloadStory: "Download Story 9:16",
      downloading: "Rendering image…",
      downloaded: "Your reading is saved as PNG.",
      saved: "Reading saved to your Journal.",
      failed: "The oracle is silent. Please try again.",
      focus: "Focus",
      exitFocus: "Exit focus",
      noCreditsTitle: "You have no reading credits",
      noCreditsBody:
        "Each reading costs 1 credit. Buy 1 reading for $2 CAD, or 3 readings for $5 CAD.",
      positions: {
        left:   "Left · Strengths",
        right:  "Right · Obstacles",
        top:    "Top · Evolution",
        bottom: "Bottom · Outcome",
        center: "Center · Synthesis",
      },
      posShort: {
        left: "Left", right: "Right", top: "Top", bottom: "Bottom", center: "Center",
      },
      posDescriptions: {
        left:   "Your strengths, resources, what helps.",
        right:  "The obstacles, tensions, what blocks.",
        top:    "The evolution and general atmosphere.",
        bottom: "The immediate outcome, the concrete answer.",
        center: "The synthesis — the key of the reading.",
      },
    },
    history: {
      title: "Reading Journal",
      empty: "No readings yet. The pages of your Journal are still blank.",
      delete: "Delete",
      confirmDelete: "Delete this reading?",
      clearAll: "Clear entire journal",
      confirmClear: "Erase every entry from your journal?",
      backToOracle: "Back to the Oracle",
      consultantLabel: "Consultant",
      crossLabel: "Cross of Five",
      statsTitle: "Journal Statistics",
      statsShow: "Show statistics",
      statsHide: "Hide statistics",
      statsTotal: "Total readings",
      statsCrossCount: "Cross readings",
      statsConsultantCount: "Consultant-only",
      statsTopCards: "Most drawn arcana",
      statsTopConsultants: "Most frequent consultant cards",
      statsByPosition: "Most drawn by position",
      statsNoData: "Draw at least one reading to see your patterns.",
      statsTimes: "×",
      streakTitle: "Current streak",
      streakDays: "day",
      streakDaysPlural: "days",
      streakLongest: "Longest",
      streakToday: "You have already consulted the oracle today.",
      streakYesterday: "Come back today to keep your streak alive.",
      streakNone: "Start a streak by drawing the cards today.",
      streakMilestone: "You've reached a personal milestone! Well done.",
      streakMilestoneTag: "Milestone reached",
    },
    footer: "Interpretations streamed live by Gemini 3.1 Pro · For reflection, not fate.",
    contact: {
      quote: "« You are the artisans of your own life, and you alone bear the responsibility for your choices. »",
      title: "To reach us.",
      emailLabel: "Your email address:",
      messageLabel: "Your message:",
      emailPlaceholder: "you@example.com",
      messagePlaceholder: "Write your message here…",
      send: "Send",
      sending: "Sending…",
      sent: "Your message has been sent. Thank you.",
      failed: "The message could not be sent. Please try again shortly.",
      errEmail: "Please enter a valid email address (max 45 characters).",
      errMessage: "Message: 1–400 characters, up to 9 lines.",
      messageCount: "{a}/400 characters · {b}/9 lines",
    },
  },
  fr: {
    brand: "Arcana Mystique",
    tagline: "Tirages de tarot",
    taglineLine2: "Murmurés par les sages",
    subhero:
      "Les 78 arcanes racontent une histoire cohérente : votre carte du consultant, puis une croix de cinq cartes tissée en une lecture vivante.",
    langLabel: "Langue",
    nav: {
      home: "Oracle",
      history: "Journal",
      begin: "Commencer le tirage",
      login: "Se connecter",
      register: "Créer un compte",
      logout: "Se déconnecter",
      account: "Compte",
      credits: "crédits",
      credit: "crédit",
      newConsultant: "Changer de consultant(e)",
      contact: "Contact",
    },
    auth: {
      loginTitle: "Connexion",
      registerTitle: "Créer votre compte",
      emailLabel: "Courriel",
      passwordLabel: "Mot de passe",
      firstNameLabel: "Prénom",
      firstNameHelp: "Maximum 15 caractères, lettres et tirets uniquement.",
      submitLogin: "Se connecter",
      submitRegister: "Créer mon compte",
      toRegister: "Pas de compte ? Créez-en un",
      toLogin: "Déjà un compte ? Connectez-vous",
      welcomeCredit: "Bienvenue — jusqu'à 3 tirages gratuits chaque jour.",
      needAuth: "Connectez-vous ou créez un compte pour tirer les cartes.",
      inlineTitle: "Continuer vers l'Oracle",
      inlineSubtitle: "Prénom & compte — moins de 20 secondes.",
      alreadyAccount: "J'ai déjà un compte",
      inlineContinueSignedIn: "Continuer en tant que",
      welcomePageTitle: "Bienvenue,",
      welcomePageIntro: "Le rituel est court. Quatre gestes, une histoire.",
      welcomeStartCta: "Commencer le tirage",
    },
    usage: {
      title: "TROIS TIRAGES GRATUITS MAXIMUM PAR JOUR",
      subtitle: "3 tirages par jour, entièrement gratuits.",
      body: "Chaque jour à minuit (UTC), le compteur est remis à zéro.\nTirez, réfléchissez, revenez demain.",
      badge: "sur 3 aujourd'hui",
      unlimited: "Illimité",
      limitReachedTitle: "Vous avez utilisé vos 3 tirages gratuits du jour",
      limitReachedBody: "Revenez demain — votre quota quotidien se renouvelle à minuit UTC.",
    },
    disclaimer: {
      title: "AVIS IMPORTANT",
      body:
        "Ce site est destiné au divertissement et à la réflexion personnelle seulement. Les informations et interprétations présentées ne constituent pas des conseils professionnels. Chaque consultant demeure entièrement responsable de ses choix, de ses décisions et des actions entreprises à la suite de l'utilisation de ce site. En utilisant ce site, le consultant reconnaît agir sous sa propre responsabilité.",
      accept: "J'ai lu et j'accepte les conditions.",
      mustAccept: "Vous devez accepter les conditions pour continuer.",
    },
    home: {
      ritual: "Le Rituel",
      cardOfTheDay: "La Carte du Jour",
      dailyTitle: "Votre carte du jour",
      cardOfTheDayIntro: "voici votre carte du jour. Retournez-la : elle donnera le ton de votre journée.",
      cardOfTheDayReveal: "Révéler la carte du jour",
      cardOfTheDayRevealing: "La carte se retourne…",
      cardOfTheDayDate: "Aujourd'hui",
      questionOfTheDay: "Question à emporter dans la journée",
      chooseTitle: "Sélectionner un tirage",
      dailyBtn: "Carte du jour",
      readingBtn: "Tirage cinq cartes",
      steps: [
        { t: "I · La Carte du Consultant", d: "Une première carte est tirée pour vous représenter à cet instant. L'oracle la lit à voix haute." },
        { t: "II · La Question", d: "Posez une question précise — ou laissez couler librement la sagesse du tarot." },
        { t: "III · La Croix de Cinq", d: "Vous placez cinq cartes : atouts, obstacles, évolution, résultat, synthèse." },
        { t: "IV · L'Histoire", d: "L'oracle relie chaque carte, tisse symboles et contradictions en une seule histoire cohérente." },
      ],
      start: "Commencer le tirage",
      deckInfo: "78 arcanes · Majeurs & Mineurs · toujours à l'endroit",
    },
    daily: {
      goReading: "Aller vers le tirage",
      finish: "Terminer",
    },
    reading: {
      phase: {
        firstName: "Votre prénom",
        consultant: "Le Consultant",
        question: "Sélectionnez votre question :",
        cross: "La Croix de Cinq",
        result: "La Lecture",
      },
      consultantLabel: "Consultant(e)",
      firstNamePrompt: "Avant de commencer, dites à l'oracle votre prénom.",
      firstNamePlaceholder: "Votre prénom",
      firstNameContinue: "Continuer",
      firstNameError: "Lettres et tirets uniquement (max 15).",
      shuffle: "Brasser le jeu",
      shuffling: "Brassage en cours…",
      drawConsultant: "Tirer la carte du consultant",
      drawing: "Tirage…",
      consultantIs: "Votre carte du consultant est",
      consultantInterp: "L'oracle vous voit",
      fiveCardsTitle: "LES 5 CARTES DE VOTRE TIRAGE",
      ritualIIIIntro: "CONCENTREZ-VOUS ET COUPEZ LE PAQUET 5 FOIS POUR CHOISIR VOS CARTES",
      deckLabel: "Le paquet · {n} cartes",
      cutPileLabel: "Mises de côté · {n} cartes",
      cutAction: "Couper le paquet",
      cutsDone: "Cinq coupes effectuées",
      cutsOf: "Coupes : {a}/5",
      cutKeyHint: "ou appuyez sur Espace · Entrée",
      cutHint: "Cliquez sur le paquet pour le couper : la carte dévoilée par chaque coupe rejoint votre croix, de dos. La partie coupée est mise de côté.",
      ritualIIIGoUnder: "ALLEZ VERS LE BAS POUR FAIRE LA SÉLECTION DE VOS 5 ARCANES PARMI LES 78 ARCANES DU TAROT",
      thinking: "L'oracle réfléchit…",
      continueToQuestion: "Continuer",
      chooseQuestionMode: "Une question personnalisée ou bien La Sagesse du Tarot",
      questionCustomBtn: "Question personnalisée",
      questionWisdomBtn: "La sagesse du tarot",
      questionLabel: "Votre question (3 lignes maximum)",
      questionPlaceholder: "Qu'est-ce qui pèse sur votre cœur aujourd'hui ?",
      questionUnclear: "L'Oracle ne comprend pas la question, la refaire.",
      noQuestion: "Je demande la sagesse du tarot",
      continueToCross: "Continuer — tirer la croix",
      pickPrompt: "Choisissez une carte pour la position",
      selectedOf: "Placées : {a}/5",
      reveal: "Révéler et interpréter",
      revealing: "Les cartes parlent…",
      restart: "Recommencer",
      backToTop: "Pour copier — retour vers le haut",
      pickCardChime: "Veuillez choisir une carte",
      newQuestion: "Une autre question · garder ce consultant",
      endSession: "Terminer la séance",
      copy: "Copier la lecture",
      copied: "Copiée dans le presse-papier.",
      print: "Imprimer / enregistrer en PDF",
      downloadImage: "Télécharger en PNG",
      shareImage: "Partager l'image",
      emailMemo: "Recevoir par courriel",
      dailyCardBtn: "Carte du jour",
      emailMemoTitle: "Recevoir une copie de ce tirage par courriel",
      emailMemoHint: "Votre adresse sert uniquement à cet envoi et n'est jamais conservée.",
      emailMemoSend: "M'envoyer le tirage",
      emailMemoSending: "Envoi en cours…",
      emailMemoSent: "Votre tirage est en route vers votre boîte de réception.",
      emailMemoFailed: "Le tirage n'a pu être envoyé. Veuillez réessayer dans un instant.",
      emailMemoInvalid: "Veuillez saisir une adresse courriel valide.",
      sharing: "Préparation de l'image…",
      shared: "Votre tirage a été partagé.",
      shareTitle: "Mon tirage de tarot · Arcana Mystique",
      shareText: "Voici mon tirage de tarot, réalisé sur Arcana Mystique.",
      downloadStory: "Télécharger Story 9:16",
      downloading: "Génération de l'image…",
      downloaded: "Votre tirage est enregistré en PNG.",
      saved: "Lecture enregistrée dans votre Journal.",
      failed: "L'oracle reste muet. Veuillez réessayer.",
      focus: "Mode focus",
      exitFocus: "Quitter le focus",
      noCreditsTitle: "Vous n'avez plus de crédits",
      noCreditsBody:
        "Chaque tirage coûte 1 crédit. Achetez 1 tirage pour 2 $ CAD, ou 3 tirages pour 5 $ CAD.",
      positions: {
        left:   "Gauche · Atouts",
        right:  "Droite · Obstacles",
        top:    "Haut · Évolution",
        bottom: "Bas · Résultat",
        center: "Centre · Synthèse",
      },
      posShort: {
        left: "Gauche", right: "Droite", top: "Haut", bottom: "Bas", center: "Centre",
      },
      posDescriptions: {
        left:   "Vos atouts, forces, ce qui aide.",
        right:  "Les obstacles, tensions, ce qui bloque.",
        top:    "L'évolution et l'ambiance générale.",
        bottom: "Le résultat immédiat, la réponse concrète.",
        center: "La synthèse — la clé du tirage.",
      },
    },
    history: {
      title: "Journal des Tirages",
      empty: "Aucun tirage pour l'instant. Les pages de votre Journal sont encore blanches.",
      delete: "Supprimer",
      confirmDelete: "Supprimer ce tirage ?",
      clearAll: "Vider tout le journal",
      confirmClear: "Effacer toutes les entrées du journal ?",
      backToOracle: "Retour à l'Oracle",
      consultantLabel: "Consultant",
      crossLabel: "Croix de Cinq",
      statsTitle: "Statistiques du Journal",
      statsShow: "Afficher les statistiques",
      statsHide: "Masquer les statistiques",
      statsTotal: "Tirages au total",
      statsCrossCount: "Tirages en croix",
      statsConsultantCount: "Cartes du consultant seules",
      statsTopCards: "Arcanes les plus tirés",
      statsTopConsultants: "Cartes du consultant les plus fréquentes",
      statsByPosition: "Cartes les plus tirées par position",
      statsNoData: "Faites au moins un tirage pour voir vos motifs.",
      statsTimes: "×",
      streakTitle: "Série actuelle",
      streakDays: "jour",
      streakDaysPlural: "jours",
      streakLongest: "Record",
      streakToday: "Vous avez déjà consulté l'oracle aujourd'hui.",
      streakYesterday: "Revenez aujourd'hui pour conserver votre série.",
      streakNone: "Commencez une série en tirant les cartes aujourd'hui.",
      streakMilestone: "Vous venez d'atteindre un palier personnel ! Bravo.",
      streakMilestoneTag: "Palier atteint",
    },
    footer: "Interprétations en direct par Gemini 3.1 Pro · Pour la réflexion, non le destin.",
    contact: {
      quote: "« Vous êtes les artisans de votre propre vie, et vous seuls portez la responsabilité de vos choix. »",
      title: "Pour nous rejoindre.",
      emailLabel: "Votre adresse courriel :",
      messageLabel: "Votre message :",
      emailPlaceholder: "vous@exemple.com",
      messagePlaceholder: "Écrivez votre message ici…",
      send: "Envoyer",
      sending: "Envoi en cours…",
      sent: "Votre message a bien été envoyé. Merci.",
      failed: "Le message n'a pas pu être envoyé. Veuillez réessayer sous peu.",
      errEmail: "Veuillez saisir une adresse courriel valide (45 caractères max).",
      errMessage: "Message : 1 à 400 caractères, 9 lignes maximum.",
      messageCount: "{a}/400 caractères · {b}/9 lignes",
    },
  },
};

export const interp = (str, vars) =>
  Object.entries(vars || {}).reduce((s, [k, v]) => s.replaceAll(`{${k}}`, v), str);

export const POSITION_KEYS = ["left", "right", "top", "bottom", "center"];
